<template>
  <div id="app">
    <Header></Header>
    <keep-alive include="Home,Aboutus,News">
      <transition name="slide-fade" mode="out-in">
        <router-view name="main"/>
      </transition>
    </keep-alive>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "./components/header";
import "./assets/iconfont/iconfont.css";
import "./assets/css/common.css";
import Footer from "./components/footer";

export default {
  name: "app",
  components: {
    Header,
    Footer
  },
  methods:{
    getKey(){
      let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'pc_home',
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              localStorage.setItem('encript_public_key',resData.data.encript_public_key)
            }
          });
    },
  },
  watch: {
    // 使用watch 监听$router的变化
    /*$route(to, from) {
      clearInterval(window.timer1);
      clearInterval(window.timer2);
      clearInterval(window.timer3);
    },*/
  },
  mounted(){
    this.getKey();
  }
};
</script>
<style lang="less" scoped>
  #app{
    background: #f0f0f0;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>

<style>

  .el-dialog__header{
    text-align: center;
  }

  .el-message-box__title{
    text-align: center;
  }

  .el-dialog__body{
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue